// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hwYGW","delete":"styles_delete__KYDW5","update":"styles_update__eFSlE","add":"styles_add__rBajb"};